import { GraphicObject } from "../graphic-object";
import { setAttrToSvgObjects } from "../utils/create-svg.js";
import { FixedDimension } from "../utils/fixed-dimension";

export class HtmlGraphicObject extends GraphicObject {
  constructor(settings) {
    super(settings);
    if (this.settings.classes === undefined) {
      this.settings.classes = [];
    }
    if (this.settings.styles === undefined) {
      this.settings.styles = [];
    }
    if (this.settings.autoCalculateBordersFunc === undefined) {
      this.settings.autoCalculateBordersFunc = HtmlGraphicObject.autoCalculateBorders;
    }
    this.settings.isCalculatedByGraphic = false;
    if (this.settings.isVisible === undefined) {
      this.settings.isVisible = true;
    }
    if (this.settings.htmlObject === undefined) {
      this.settings.htmlObject = {};
    }
    // margin
    if (this.settings.htmlObject.margin === undefined) {
      this.settings.htmlObject.margin = {};
    }
    if (this.settings.htmlObject.margin.left === undefined) {
      this.settings.htmlObject.margin.left = this.settings.margin.left.copy();
    }
    if (this.settings.htmlObject.margin.right === undefined) {
      this.settings.htmlObject.margin.right = this.settings.margin.right.copy();
    }
    if (this.settings.htmlObject.margin.top === undefined) {
      this.settings.htmlObject.margin.top = this.settings.margin.top.copy();
    }
    if (this.settings.htmlObject.margin.bottom === undefined) {
      this.settings.htmlObject.margin.bottom = this.settings.margin.bottom.copy();
    }
    // paddings
    if (this.settings.htmlObject.padding === undefined) {
      this.settings.htmlObject.padding = {};
    }
    if (this.settings.htmlObject.padding.left === undefined) {
      this.settings.htmlObject.padding.left = this.settings.padding.left.copy();
    }
    if (this.settings.htmlObject.padding.right === undefined) {
      this.settings.htmlObject.padding.right = this.settings.padding.right.copy();
    }
    if (this.settings.htmlObject.padding.top === undefined) {
      this.settings.htmlObject.padding.top = this.settings.padding.top.copy();
    }
    if (this.settings.htmlObject.padding.bottom === undefined) {
      this.settings.htmlObject.padding.bottom = this.settings.padding.bottom.copy();
    }
    if (this.settings.htmlObject.parent === undefined) {
      this.settings.htmlObject.parent = {};
    }

    if (
      this.settings.htmlObject.parent.ref === undefined ||
      this.settings.htmlObject.parent.size === undefined ||
      this.settings.htmlObject.location === undefined ||
      this.settings.htmlObject.size === undefined
    ) {
      // need set this.settings.htmlObject.graphicParent !== undefined
      this.settings.isCalculatedByGraphic = true;
      this.settings.autoCalculateBordersFunc(this.settings);
    }

    HtmlGraphicObject.calculateHtmlBorders(this.settings);
    this.settings.debug.boxFillColor = "orange";
    this.settings.debug.boxOutline = "2px solid brown";
  }

  static autoCalculateBorders(settings) {
    HtmlGraphicObject.autoCalculateSize(settings);
    HtmlGraphicObject.autoCalculateLocation(settings);
  }

  static autoCalculateSize(settings) {
    settings.htmlObject.parent.size = {
      width: settings.htmlObject.graphicParent.settings.htmlObject.clientSize.width,
      height: settings.htmlObject.graphicParent.settings.htmlObject.clientSize.height
    };
    settings.htmlObject.marginInPixels = {
      left: settings.htmlObject.margin.left.calcValue(settings.htmlObject.parent.size.width),
      right: settings.htmlObject.margin.right.calcValue(settings.htmlObject.parent.size.width),
      top: settings.htmlObject.margin.top.calcValue(settings.htmlObject.parent.size.height),
      bottom: settings.htmlObject.margin.bottom.calcValue(settings.htmlObject.parent.size.height)
    };
    settings.htmlObject.size = {
      width: new FixedDimension(settings.sizeInPixels.width + settings.marginInPixels.left + settings.marginInPixels.right),
      height: new FixedDimension(settings.sizeInPixels.height + settings.marginInPixels.top + settings.marginInPixels.bottom)
    };
  }

  static autoCalculateX(settings) {
    return (
      settings.absoluteLocation.x -
      settings.htmlObject.graphicParent.settings.absoluteLocation.x -
      settings.htmlObject.graphicParent.settings.clientLocation.x
    );
  }

  static autoCalculateY(settings) {
    return (
      settings.htmlObject.parent.size.height -
      (settings.absoluteLocation.y -
        settings.htmlObject.graphicParent.settings.absoluteLocation.y +
        settings.htmlObject.graphicParent.settings.clientLocation.y +
        settings.htmlObject.size.height.value) +
      settings.htmlObject.marginInPixels.top
    );
  }

  static autoCalculateLocation(settings) {
    const htmlX = HtmlGraphicObject.autoCalculateX(settings);
    const htmlY = HtmlGraphicObject.autoCalculateY(settings);
    settings.htmlObject.location = {
      x: new FixedDimension(htmlX),
      y: new FixedDimension(htmlY)
    };
  }

  static findHtmlGraphicObject(graphicObject) {
    if (graphicObject == undefined || graphicObject == null) {
      return undefined;
    } else if (graphicObject instanceof HtmlGraphicObject) {
      return graphicObject;
    } else if (graphicObject.settings.parent?.ref === undefined) {
      return undefined;
    } else {
      return HtmlGraphicObject.findHtmlGraphicObject(graphicObject.settings.parent.ref);
    }
  }

  static setHtmlObject(settings, htmlObject) {
    settings.htmlObject.ref = htmlObject;
    // settings.htmlObject.parent.ref is parent html object, can be equals settings.htmlObject.graphicParent.settings.htmlObject.ref
    if (settings.htmlObject.parent?.ref !== undefined) {
      settings.htmlObject.parent.ref.appendChild(htmlObject);
    }
  }

  // calculate locations in pixels
  static calculateHtmlBorders(settings) {
    // if parent is null, we has html parent object with coord system: (0, 0) in left-top corner
    // in this case object location will have html object's system: (0, 0) in left-top corner
    settings.htmlObject.marginInPixels = {
      left: settings.htmlObject.margin.left.calcValue(settings.htmlObject.parent.size.width),
      right: settings.htmlObject.margin.right.calcValue(settings.htmlObject.parent.size.width),
      top: settings.htmlObject.margin.top.calcValue(settings.htmlObject.parent.size.height),
      bottom: settings.htmlObject.margin.bottom.calcValue(settings.htmlObject.parent.size.height)
    };
    settings.htmlObject.sizeInPixels = {
      width:
        settings.htmlObject.size.width.calcValue(settings.htmlObject.parent.size.width) -
        settings.htmlObject.marginInPixels.left -
        settings.htmlObject.marginInPixels.right,
      height:
        settings.htmlObject.size.height.calcValue(settings.htmlObject.parent.size.height) -
        settings.htmlObject.marginInPixels.top -
        settings.htmlObject.marginInPixels.bottom
    };
    settings.htmlObject.locationInPixels = {
      x: settings.htmlObject.location.x.calcValue(
        settings.htmlObject.parent.size.width - settings.htmlObject.marginInPixels.left - settings.htmlObject.marginInPixels.right
      ),
      y: settings.htmlObject.location.y.calcValue(
        settings.htmlObject.parent.size.height - settings.htmlObject.marginInPixels.top - settings.htmlObject.marginInPixels.bottom
      )
    };
    // location in system: (0,0) is left-bottom parent's corner
    settings.htmlObject.absoluteLocation = {
      x: settings.htmlObject.locationInPixels.x + settings.htmlObject.marginInPixels.left,
      y: settings.htmlObject.locationInPixels.y + settings.htmlObject.marginInPixels.bottom
    };
    settings.htmlObject.paddingInPixels = {
      left: settings.htmlObject.padding.left.calcValue(settings.htmlObject.sizeInPixels.width),
      right: settings.htmlObject.padding.right.calcValue(settings.htmlObject.sizeInPixels.width),
      top: settings.htmlObject.padding.top.calcValue(settings.htmlObject.sizeInPixels.height),
      bottom: settings.htmlObject.padding.bottom.calcValue(settings.htmlObject.sizeInPixels.height)
    };
    settings.htmlObject.clientLocation = {
      x: settings.htmlObject.paddingInPixels.left,
      y: settings.htmlObject.paddingInPixels.bottom
    };
    settings.htmlObject.clientSize = {
      width: settings.htmlObject.sizeInPixels.width - settings.htmlObject.clientLocation.x - settings.htmlObject.paddingInPixels.right,
      height: settings.htmlObject.sizeInPixels.height - settings.htmlObject.clientLocation.y - settings.htmlObject.paddingInPixels.top
    };
  }

  addClass(className) {
    if (!this.settings.classes.includes(className)) {
      this.settings.classes.push(className);
      this.onAddClass(className);
    }
  }

  onAddClass(className) {
    this.settings.htmlObject.ref.classList.add(className);
  }

  removeClass(className) {
    for (let i = 0; i < this.settings.classes.length; ++i) {
      if (this.settings.classes[i] == className) {
        this.settings.classes.splice(i, 1);
        this.onRemoveClass(className);
        return;
      }
    }
  }

  onRemoveClass(className) {
    this.settings.htmlObject.ref.classList.remove(className);
  }

  addStyle(cssText) {
    this.settings.styles.push(cssText);
    this.onAddStyle(cssText);
  }

  onAddStyle(cssText) {
    const stylesheet = new CSSStyleSheet();
    stylesheet.insertRule(cssText);
    document.adoptedStyleSheets = [stylesheet];
  }

  getVisibility() {
    return this.settings.isVisible;
  }

  setVisibility(isVisible) {
    this.settings.isVisible = isVisible;
    this.settings.htmlObject.ref.style.visibility = isVisible ? "visible" : "collapse"; // visible | hidden | collapse
  }

  addEventListener(eventType, action) {
    this.settings.htmlObject.ref.addEventListener(eventType, action);
  }

  removeEventListener(eventType, action) {
    this.settings.htmlObject.ref.removeEventListener(eventType, action);
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    if (debugSettings.strokeHtmlElements) {
      this.settings.htmlObject.ref.style.outline = this.settings.debug.boxOutline;
    }
  }

  setLocation(x, y) {
    super.setLocation(x, y);
    this.setHtmlLocation(x, y);
  }

  setSize(width, height) {
    super.setSize(width, height);
    this.setHtmlSize(width, height);
  }

  setBorders(location, size) {
    super.setBorders(location, size);
    this.setHtmlBorders(location, size);
  }

  setParentSize(width, height) {
    super.setParentSize(width, height);
    this.setHtmlParentSize(width, height);
  }

  // x: new ScalableDimension(0, 0), y: new ScalableDimension(0, 0)
  updateHtmlLocation(x, y) {
    if (this.settings.htmlObject.location.x.isEquals(x) && this.settings.htmlObject.location.y.isEquals(y)) {
      return false;
    }
    this.setHtmlLocation(x, y);
    this.createHtmlBorders();
    return true;
  }

  setHtmlLocation(x, y) {
    this.settings.htmlObject.location = {
      x: x,
      y: y
    };
  }

  // width: new ScalableDimension(0, 0), height: new ScalableDimension(0, 0)
  // return: true - size is updated, false - size is not updated
  updateHtmlSize(width, height) {
    if (this.settings.htmlObject.size.width.isEquals(width) && this.settings.htmlObject.size.height.isEquals(height)) {
      return false;
    }
    this.setHtmlSize(width, height);
    this.createHtmlBorders();
    return true;
  }

  setHtmlSize(width, height) {
    this.settings.htmlObject.size = {
      width: width,
      height: height
    };
  }

  // location: { x: new ScalableDimension(0, 0), y: new ScalableDimension(0, 0) }
  // size: { width: new ScalableDimension(0, 0), height: new ScalableDimension(0, 0) }
  // return: true - borders are updated, false - borders are not updated
  updateHtmlBorders(location, size) {
    if (
      this.settings.htmlObject.location.x.isEquals(location.x) &&
      this.settings.htmlObject.location.y.isEquals(location.y) &&
      this.settings.htmlObject.size.width.isEquals(size.width) &&
      this.settings.htmlObject.size.height.isEquals(size.height)
    ) {
      return false;
    }
    this.setHtmlBorders(location, size);
    this.createHtmlBorders();
    return true;
  }

  setHtmlBorders(location, size) {
    this.settings.htmlObject.location = location;
    this.settings.htmlObject.size = size;
  }

  // where parent - html object
  // width: new ScalableDimension(0, 0), height: new ScalableDimension(0, 0)
  updateHtmlParentSize(width, height) {
    if (this.settings.htmlObject.parent.size.width == width && this.settings.htmlObject.parent.size.height == height) {
      return false;
    }
    this.setHtmlParentSize(width, height);
    this.createHtmlBorders();
    return true;
  }

  setHtmlParentSize(width, height) {
    this.settings.htmlObject.parent.size = {
      width: width,
      height: height
    };
  }

  getHtmlObjectRealBorders() {
    return this.settings.htmlObject.ref.getBBox();
  }

  update(fieldName, newValue) {
    setAttrToSvgObjects(this.settings.htmlObject.ref, [fieldName, newValue]);
  }

  removeObjectFromDom() {
    this.settings.htmlObject.ref.remove();
  }

  createBorders() {
    super.createBorders();
    this.createHtmlBorders();
  }

  createHtmlBorders() {
    if (this.settings.isCalculatedByGraphic) {
      this.settings.autoCalculateBordersFunc(this.settings);
    }

    HtmlGraphicObject.calculateHtmlBorders(this.settings);
  }
}
